import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { JwtModelBase } from './JwtModel.base'

/* The TypeScript type of an instance of JwtModel */
export interface JwtModelType extends RecursiveRemoveUndefined<Instance<typeof JwtModel>> {}

/* A graphql query fragment builders for JwtModel */
export { selectFromJwt, jwtModelPrimitives, JwtModelSelector } from './JwtModel.base'

/**
 * JwtModel
 */
export const JwtModel = JwtModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
